import { render, staticRenderFns } from "./DdConstruct.vue?vue&type=template&id=16f64a5a&scoped=true"
import script from "./DdConstruct.vue?vue&type=script&lang=js"
export * from "./DdConstruct.vue?vue&type=script&lang=js"
import style0 from "./DdConstruct.vue?vue&type=style&index=0&id=16f64a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f64a5a",
  null
  
)

export default component.exports